export function historyAnchors() {
    const yearsListItems = $('.years-list .item');
    const historyListItems = $('.history-list .item');

    yearsListItems.each((i, item) => {
        const title = $(item).find('a').text().toLowerCase();
        $(item).find('a').attr('href', title);
    });

    historyListItems.each((i, item) => {
        const title = $(item).find('.year').text().toLowerCase();
        $(item).attr('id', title);
    });


    $(document).on('click', '.years-list a', function (e) {
        e.preventDefault();
        const $this = $(this);
        const headerHeight = $('.header').innerHeight();
        const href = $(this).attr('href');
        const section = $(`#${href}`);

        $('.years-list .item').removeClass('active');
        $this.parent().addClass('active');
        $("html, body").animate({scrollTop: section.offset().top - headerHeight}, 1000);
    });

    $('.years-list').slick({
        slidesToShow: 5,
        slidesToScroll: 3,
        mobileFirst: true,
        infinite: false,
        speed: 300,
        edgeFriction: 0.1,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" style=""><svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M7.20213 10V5.50562H18.5V4.49438H7.20213V0L0.5 4.98876L7.20213 10Z" fill="#133440"/>\n' +
            '</svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M11.7979 10V5.50562H0.5V4.49438H11.7979V0L18.5 4.98876L11.7979 10Z" fill="#133440"/>\n' +
            '</svg></button > ',
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 10
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 16
                }
            }
        ]
    });

    $(window).scroll(function () {
        let el = $('.years-list'),
            eli = $('.years-nav'),
            hT = eli.offset().top,
            wS = $(this).scrollTop();

        if (wS > (hT + 10)) {
            if (!el.hasClass('on-top')) {
                el.addClass('on-top')
            }

        } else {
            if (el.hasClass('on-top')) {
                el.removeClass('on-top');
            }
        }
        $('.history-list > .item').each(function () {
            let thisTop = $(this).offset().top,
                currentId = $(this).attr("id"),
                currentSlide = $('.years-list [href*=' + currentId + ']');

            if (wS > (thisTop - 150)) {
                $('.years-list .item a').removeClass('current');
                if (!currentSlide.hasClass('current')) {
                    currentSlide.addClass('current');
                }

            }
        })
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/historyAnchors.js